
import {Component, Prop, Vue} from "vue-property-decorator";
import {IlamBilgisiEntity} from "@/entity/IlamBilgisiEntity";
import {IlamTipi, IlamTipiLabel} from "@/enum/IlamTipi";

interface GorunenAlan {
  etiket: string;
  deger: string;
  ikon: string;
}

@Component
export default class IlamBilgileriInfo extends Vue {
  @Prop({default: () => []}) items!: Array<IlamBilgisiEntity>;

  get ilamlar(): Array<IlamBilgisiEntity> {
    return this.items ?? [];
  }

  /**
   * "İlamı veren" alanının etiketi ilam tipine göre değişiyor; mahkeme dışındaki
   * tiplerde "Mahkeme Adı" demek yanlış olurdu.
   */
  private ilamiVerenEtiketi(ilamTipi: string | null): string {
    switch (ilamTipi) {
      case IlamTipi.mahkeme:
        return 'Mahkeme Adı';
      case IlamTipi.noter:
        return IlamTipiLabel.noter;
      case IlamTipi.hakem_karari:
        return IlamTipiLabel.hakem_karari;
      case IlamTipi.arabulucu:
        return IlamTipiLabel.arabulucu;
      default:
        return 'İlamı Veren Kurum';
    }
  }

  /**
   * Sadece dolu alanlar satır olur: noter senedinde esas/karar no, mahkeme
   * ilamında yevmiye no boş kalır ve o satırlar hiç basılmaz.
   */
  gorunenAlanlar(ilam: IlamBilgisiEntity): Array<GorunenAlan> {
    const adaylar: Array<GorunenAlan | null> = [
      ilam.ilami_veren
          ? {etiket: this.ilamiVerenEtiketi(ilam.ilam_tipi), deger: ilam.ilami_veren, ikon: 'mdi-bank'}
          : null,
      // "İlam Türü" olarak dosya türü gösteriliyor: Alacaklar formunda kullanıcının
      // kendi seçtiği alan bu ve 11 ayrı değerle ayırt edici. Üst kırılım olan
      // ilam_turleri ("Hukuk/Ceza/İdare Mahkemesi") mahkeme adının yanında
      // tekrar olurdu.
      ilam.dosya_turu
          ? {etiket: 'İlam Türü', deger: ilam.dosya_turu, ikon: 'mdi-scale-balance'}
          : null,
      ilam.esas_no
          ? {etiket: 'Esas No', deger: String(ilam.esas_no), ikon: 'mdi-folder-text'}
          : null,
      ilam.karar_no
          ? {etiket: 'Karar No', deger: String(ilam.karar_no), ikon: 'mdi-gavel'}
          : null,
      ilam.yevmiye_no
          ? {etiket: 'Yevmiye No', deger: String(ilam.yevmiye_no), ikon: 'mdi-numeric'}
          : null,
      ilam.karar_tarihi
          ? {etiket: 'Karar Tarihi', deger: this.$helper.tarihStr(ilam.karar_tarihi), ikon: 'mdi-calendar'}
          : null,
    ];

    return adaylar.filter((alan): alan is GorunenAlan => alan !== null);
  }
}
